import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  // base: "/zh_CN",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.path.includes("/Case") && !to.meta.scroll) {
      return false;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  routes: [
    {
      path: "/",
      component: () => import("../views/About.vue"),

      meta: {
        title: "关于拓弗勒",
        enTitle: 'ABOUT TOPS',
        deTitle: "ÜBER TOPS",
      }
    },
    {
      path: "/Index",
      component: () => import("../views/About.vue"),
      meta: {
        title: "关于拓弗勒",
        enTitle: 'ABOUT TOPS',
        deTitle: "ÜBER TOPS",
      }
    },
    {
      path: "/Leads",
      component: () => import("../views/Leads.vue"),

      meta: {
        title: "拓弗勒-在线登记",
        enTitle: 'TOPS-Online registration',
        deTitle: "TOPS-Online-Anmeldung",
      }
    },

    {
      path: "/Product",
      component: () => import("../views/Product.vue"),

      meta: {
        title: "产品中心",
        enTitle: 'Product Center',
        deTitle: "Produktzentrum",
      },
      children: [
        {
          path: "ColorChange",
          component: () => import("../views/product/ColorChange"),
          meta: {
            title: "改色膜",
            keepAlive: true,
            enTitle: 'Wrapping Film',
            deTitle: "Folien",
          }
        },
        {
          path: "Colorful/:id?",
          component: () => import("../views/product/Colorful.vue"),
          meta: {
            title: "炫彩膜",
            enTitle: 'Colorful Film',
            deTitle: "Bunte Folie",
          }
        },
        {
          path: "G",
          component: () => import("../views/product/G.vue"),
          meta: {
            title: "G速膜",
            enTitle: 'G Film (Window Film)',
            deTitle: "G-Folie (Fensterfolie)",
          }
        },
        {
          path: "HeadlightFilm",
          component: () => import("../views/product/HeadlightFilm.vue"),
          meta: {
            title: "大灯膜",
            enTitle: 'TPU Headlight Film',
            deTitle: "TPU Scheinwerferfolie",
          }
        },
        {
          path: "Paint",
          component: () => import("../views/product/Paint.vue"),
          meta: {
            title: "漆面保护膜",
            enTitle: 'Paint Protection Film',
            deTitle: "Lackschutzfolie",
          }
        },
        {
          path: "SkyLight",
          component: () => import("../views/product/SkyLight.vue"),
          meta: {
            title: "天窗膜",
            enTitle: 'Sunroof Protection Film',
            deTitle: "Schiebedach-Schutzfolie",
          }
        }
      ]
    },
    {
      path: "/PaintDetail/:id",
      name: "PaintDetail",
      component: () => import("../views/Product/detail/PaintDetail.vue"),
      meta: {
        title: "漆面膜详情页面",
        enTitle: 'Paint Protection Film Info',
        deTitle: "Lackschutzfolie Info",
      }
    },
    {
      path: "/GDetail/:id",
      name: "GDetail",
      component: () => import("../views/Product/detail/GDetail"),
      meta: {
        title: "G速膜详情页面",
        enTitle: 'G Film Info',
        deTitle: "G-Folie Info",
      }
    },
    {
      path: "/ColorChangeSeries/:id",
      name: "ColorChangeSeries",
      component: () => import("../views/Product/detail/ColorChangeSeries.vue"),
      meta: {
        title: "改色膜详情页面",
        enTitle: 'Wrapping Film Info',
        deTitle: "Folien Info",
        // keepAlive: true
      }
    },
    {
      path: "/ColorChangeSeriesDetail/:id",
      name: "ColorChangeSeriesDetail",
      component: () =>
        import("../views/Product/detail/ColorChangeSeriesDetail.vue"),
      meta: {
        title: "改色膜详情页面",
        enTitle: 'Wrapping Film Info',
        deTitle: "Folien Info",
      }
    },
    {
      path: "/ColorfulDetail/:id",
      name: "ColorfulDetail",
      component: () => import("../views/Product/detail/ColorfulDetail.vue"),
      meta: {
        title: "炫彩膜详情页面",
        enTitle: 'Colorful Film Info',
        deTitle: "Bunte Folie Info",
      }
    },
    {
      path: "/SkyLightDetail/:id",
      name: "SkyLightDetail",
      component: () => import("../views/Product/detail/SkyLightDetail.vue"),
      meta: {
        title: "天窗膜详情页面",
        enTitle: 'Sunroof Protection Film Info',
        deTitle: "Schiebedach-Schutzfolie Info",
      }
    },
    {
      path: "/Solution",
      name: "Solution",
      component: () => import("../views/Solution/index.vue"),
      meta: {
        title: "解决方案",
        enTitle: 'Solution',
        deTitle: "Lösung",
      },
      children: [
        {
          path: "Train",
          component: () => import("../views/Solution/Train.vue"),
          meta: {
            title: "安装培训",
            enTitle: 'Installation Training',
            deTitle: "Installationstraining",
          }
        },
        {
          path: "Train2",
          component: () => import("../views/Solution/Train2.vue"),
          meta: {
            title: "窗膜安装培训",
            enTitle: 'Film Installation Training',
            deTitle: "Folien-Installationstraining",
          }
        },
        {
          path: "Installer",
          component: () => import("../views/Solution/Installer.vue"),
          meta: {
            title: "加入经销商",
            enTitle: 'Join Dealer',
            deTitle: "Händler werden",
          }
        },
        {
          path: "DAS",
          component: () => import("../views/Solution/DAS.vue"),
          meta: {
            title: "DAS 3D裁膜数据辅助系统",
            enTitle: 'DAS',
            deTitle: "DAS",
          }
        }
      ]
    },
    {
      path: "/Case/:code",
      name: "Case",
      component: () => import("../views/Case.vue"),
      meta: {
        title: "精彩案例",
        enTitle: 'Installation Cases',
        deTitle: "Installationsfälle",
      }
    },
    {
      path: "/CaseDetail/:id",
      name: "CaseDetail",
      component: () => import("../views/CaseDetail.vue"),
      meta: {
        title: "案例详情",
        enTitle: 'Case Info',
        deTitle: "Fall Info",
      }
    },
    {
      path: "/Dynamic",
      component: () => import("../views/Dynamic.vue"),
      meta: {
        title: "品牌动态",
        keepAlive: true,
        enTitle: 'News Center',
        deTitle: "Nachrichtenzentrum",
      }
    },
    {
      path: "/DynamicDetail/:id",
      component: () => import("../views/DynamicDetail.vue"),
      meta: {
        title: "品牌动态详情页",
        enTitle: 'News Center Info',
        deTitle: "Nachrichtenzentrum Info",
      }
    },
    {
      path: "/Help",
      component: () => import("../views/help.vue"),
      meta: {
        title: "帮助",
        enTitle: 'Help',
        deTitle: "Hilfe",
      },
      children: [
        {
          path: "Support",
          component: () => import("../views/help/Support.vue"),
          meta: {
            title: "技术支持",
            enTitle: 'Technical Support',
            deTitle: "Technischer Support",
          }
        },
        {
          path: "Problem",
          component: () => import("../views/help/Problem.vue"),
          meta: {
            title: "常见问题",
            enTitle: 'Frequently Asked Questions',
            deTitle: "Häufig gestellte Fragen",
          }
        },
        {
          path: "Authentication",
          component: () => import("../views/help/Authentication.vue"),
          meta: {
            title: "认证",
            enTitle: 'Authentication',
            deTitle: "Authentifizierung",
          }
        },
        {
          path: "Maintain",
          component: () => import("../views/help/Maintain.vue"),
          meta: {
            title: "保养",
            enTitle: 'Maintenance',
            deTitle: "Wartung",
          }
        },
        {
          path: "SafelyFactor",
          component: () => import("../views/help/SafelyFactor.vue"),
          meta: {
            title: "产品安全参数",
            enTitle: 'Product safety parameters',
            deTitle: "Produktsicherheitsparameter",
          }
        },
        {
          path: "Warranty",
          component: () => import("../views/help/Warranty.vue"),
          meta: {
            title: "质保信息",
            enTitle: 'WARRANTY Info',
            deTitle: "GARANTIE Info",
          }
        },
        {
          path: "Guidance",
          component: () => import("../views/help/Guidance.vue"),
          meta: {
            title: "安装指导",
            enTitle: 'Installation Guide',
            deTitle: "Installationsanleitung",
          }
        }
      ]
    },
    // 查询
    {
      path: "/Query",
      component: () => import("../views/Query.vue"),
      children: [
        {
          path: "Warranty",
          component: () => import("../views/query/Warranty.vue"),
          meta: {
            title: "质保查询",
            enTitle: 'Warranty Inquiry',
            deTitle: "Garantieanfrage",
          }
        },
        {
          path: "Distributor",
          component: () => import("../views/query/Distributor.vue"),
          meta: {
            title: "经销商查询",
            enTitle: 'Find Dealer',
            deTitle: "Händler finden",
          }
        },
        {
          path: "Offer",
          component: () => import("../views/query/Offer.vue"),
          meta: {
            title: "报价查询",
            enTitle: 'Price Inquiry',
            deTitle: "Preisanfrage",
          }
        }
      ]
    },
    //===============
    {
      path: "/Home",
      component: () => import("../views/Home.vue"),
      meta: {
        title: "Home",
        keepAlive: true,
        enTitle: 'Home',
        deTitle: "Startseite",
      }
    },
    {
      path: "/MobileWarranty",
      component: () => import("../views/query/MobileWarranty.vue"),
      meta: {
        title: "质保查询",
        enTitle: 'Warranty Inquiry',
        deTitle: "Garantieanfrage",
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js